import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {AcademicYear} from "../../models/academic-year.model";
import {AcademicCalendarService} from "../../services/academic-calendar.service";
import { SettingService } from '../../services/setting.service';

@Component({
  selector: 'app-select-academic-year-only',
  templateUrl: './select-academic-year-only.component.html',
  styleUrls: ['./select-academic-year-only.component.css']
})
export class SelectAcademicYearOnlyComponent implements OnInit {

  heading = 'Academic Year Select';
  localStorageName = 'client.aydata';
  academicYearValue: any;
  academicYears: any;
  currentAcademicYear: any;
  periodId: number;
  loading: boolean;
  tempOfPeriod: any;

  @Output()
  academicYearChanged = new EventEmitter<AcademicYear>();

  @Input()
  academic_year = null;

  @Input()
  all = false;

  @Input()
  all_academic_year = false;

  @Input()
  approver_setup_module = null;

  @Input()
  isDisabled = false;

  @Input()
  clear = true;

  @Input()
  currentPeriodOnly = true;

  @Input()
  group_by_period = false;

  placeholder= "{{(all ? 'ALL' : 'SELECT') | translate}} {{ 'ACADEMIC_YEAR' | translate }}"


  constructor(private acService: AcademicCalendarService,
              private toastr: ToastrService,
              private setting: SettingService
            ) {
  }

  ngOnInit() {
    this.getAcademicYear();
    this.onCheckLocalStorage();
  }

  onCheckLocalStorage() {
    const val = JSON.parse(<string>this.setting.getConfig(this.localStorageName));
    if (val) {
      this.academicYearValue = this.group_by_period ? (val.period_id || val.academic_year) : val.academic_year;
      this.academicYearChanged.emit(val);
    }
  }

  getAcademicYear() {
    this.loading = true;
    const request$ = (this.group_by_period || this.all_academic_year)
      // @ts-ignore
      ? this.acService.getAcademicYears()
      // @ts-ignore
      : this.acService.getAcademicYearsOnly({
          approver_setup_module: this.approver_setup_module,
        });

    // @ts-ignore
    request$
        .subscribe((response: any) => {
          if (response['error'] === 0) {
            // @ts-ignore
            let tempOfAcademicYear = [];
            this.academicYears = response['result']['data'] || [];

            if (this.group_by_period) {
              this.academicYears = this.academicYears.map((item: any) => ({
                academic_year: item.academic_year,
                period_id: item.period_id,
                period_name: item.period_name,
              }))
              .sort((a: any, b: any) => {
                if (a.academic_year === b.academic_year) {
                  return (a.period_name || '').localeCompare(b.period_name || '');
                }
                return `${b.academic_year}`.localeCompare(`${a.academic_year}`);
              });
              this.getCurrentAcademicYear();
              return;
            }

            if (this.academicYears.length > 0 && !this.all_academic_year) {
              const newestYear = this.academicYears[0].academic_year;
              if (newestYear) {
                const firstYear = Number(newestYear.split('-')[0]) + 1;
                const lastYear = Number(newestYear.split('-')[1]) + 1;
                this.academicYears.unshift({ academic_year: `${firstYear}-${lastYear}` });
              }
            }

            this.tempOfPeriod = this.academicYears;
            // @ts-ignore
            this.academicYears = this.academicYears.map(function(i) {
              return i.academic_year;
            });
            this.academicYears = this.academicYears.filter((v: any, i: any, a: string | any[]) => a.indexOf(v) === i);

            this.academicYears.forEach(function(i: any) {
              tempOfAcademicYear.push({
                academic_year: i,
                period_id: null,
              });
            });
            // @ts-ignore
            tempOfAcademicYear = tempOfAcademicYear;
            this.academicYears = tempOfAcademicYear;
            this.getCurrentAcademicYear();
          } else {
            this.loading = false;
            this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
          }
        }, (error: any) => {
          this.loading = false;
          this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
        });
  }

  getCurrentAcademicYear() {
    this.acService.getAcademicYearsOnlyCurrent()
        .subscribe((response: AcademicYear) => {
          // @ts-ignore
          if (response['error'] === 0) {
            this.loading = false;
            // @ts-ignore
            this.currentAcademicYear = new AcademicYear().deserialize(response['result']['data']);
            let current;
            let currentPeriod;
            currentPeriod = this.currentAcademicYear;
            if (this.group_by_period) {
              if (this.academic_year) {
                // @ts-ignore
                current = this.academicYears.find(i => i.academic_year === this.academic_year);
              } else {
                // @ts-ignore
                current = this.academicYears.find(i => `${i.period_id}` === `${currentPeriod.period_id}`) || this.academicYears.find(i => i.academic_year === currentPeriod.academic_year);
              }
            } else {
              if (this.academic_year) {
                // @ts-ignore
                current = this.academicYears.find(i => i.academic_year === this.academic_year);
              } else {
                // @ts-ignore
                current = this.academicYears.find(i => i.academic_year === this.currentAcademicYear.academic_year);
              }

              if (currentPeriod) {
                // @ts-ignore
                this.academicYears = this.academicYears.map(function(i) {
                  i.academic_year = i.academic_year;
                  i.period_id = currentPeriod.period_id;
                  return i;
                });
              }
            }

            if (!this.academicYearValue && current) {
              if (!this.group_by_period) {
                this.academicYears.forEach(function(i: any) {
                  i.period_id = currentPeriod.period_id;
                });
                this.academicYearValue = current.academic_year;
              } else {
                this.academicYearValue = current.period_id;
              }
              this.academicYearChanged.emit(current);
            }
          } else {
            this.loading = false;
            // @ts-ignore
            this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
          }
        }, (error: any) => {
          this.loading = false;
          this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
        });
  }

  onChange(item: any) {
    if (!this.academicYearValue) {
      this.academicYearChanged.emit(undefined);
      return;
    }
    const selected = this.group_by_period
      // @ts-ignore
      ? this.academicYears.find((i: any) => `${i.period_id}` === `${item ? item.period_id || item : item}` && i.academic_year === (item ? item.academic_year : item))
      // @ts-ignore
      : this.academicYears.find((i: any) => i.academic_year === (item ? item.academic_year || item : item));
    this.academicYearChanged.emit(selected);
    this.onSaveLocalStorage(selected);
  }

  onSaveLocalStorage(selected: any) {
    this.setting.setConfig(this.localStorageName, JSON.stringify(selected));
  }

  onlyUnique(value: any, index: any, self: string | any[]) {
    return self.indexOf(value) === index;
  }

}
